import { render, staticRenderFns } from "./Price.vue?vue&type=template&id=58a191f7"
import script from "./Price.vue?vue&type=script&lang=js"
export * from "./Price.vue?vue&type=script&lang=js"
import style0 from "./Price.vue?vue&type=style&index=0&id=58a191f7&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58a191f7')) {
      api.createRecord('58a191f7', component.options)
    } else {
      api.reload('58a191f7', component.options)
    }
    module.hot.accept("./Price.vue?vue&type=template&id=58a191f7", function () {
      api.rerender('58a191f7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/preview/Price.vue"
export default component.exports